import React, { useState } from "react";
import PropTypes from "prop-types";
import CustomTab from "../../../../../../app/common-components/Tab";
import CisBenchmarkExclusions from "./TenableSecurityCenter/CISBenchmark/CisBenchmarkExclusions/CisBenchmarkExclusionsPage";
import CISBenchmarkSLAConfigRoles from "./TenableSecurityCenter/CISBenchmark/CISBenchmarkSLAConfigTable";
import FirstSeenOffsetConfiguration from "./TenableSecurityCenter/VulnerabilityManagement/FirstSeenOffsetConfiguration";
import SeveritySLAConfigRoles from "./TenableSecurityCenter/VulnerabilityManagement/SLAConfigurationTable";
import TypeConfigurationTable from "./TenableSecurityCenter/VulnerabilityManagement/TypeConfiguration";
import DefaultToolTable from "./DefaultToolTable";
import CisBenchmarkFirstSeenConfiguration from "./TenableSecurityCenter/CISBenchmark/CisBenchmarkFirstSeenConfiguration";
import VulnerabilityManagementExclusion from "../VulnerabilityManagementExclusion/VulnerabilityManagementExclusion";

const VulnerabilityManagementTab = () => (
  <div>
    <div className="mb-4">
      <SeveritySLAConfigRoles />
    </div>
    <div className="mb-4">
      <FirstSeenOffsetConfiguration />
    </div>
    <div className="mb-4">
      <VulnerabilityManagementExclusion />
    </div>
    <div className="mb-4">
      <TypeConfigurationTable />
    </div>
  </div>
);

const CISBenchmarkTab = () => (
  <div>
    <div className="mb-4">
      <CISBenchmarkSLAConfigRoles />
    </div>
    <div className="mb-4">
      <CisBenchmarkFirstSeenConfiguration/>
    </div>
    <div className="mb-4">
      <CisBenchmarkExclusions />
    </div>
  </div>
);

const TAB_KEYS = {
  VULNERABILITY_MANAGEMENT: "vulnerabilityManagement",
  CIS_BENCHMARK: "cisBenchmark",
};

const TENABLE_TABS = [
  { text: "Vulnerability Management", key: TAB_KEYS.VULNERABILITY_MANAGEMENT },
  { text: "CIS Benchmark",            key: TAB_KEYS.CIS_BENCHMARK },
];

const DEFAULT_TAB_DATA = [
    {
      text: "CIS Benchmark",
      function: <DefaultToolTable />,
      key: "cisBenchmark",
    },
];

const ConfigTables = ({ toolName }) => {
  const isTenable = toolName?.includes("Tenable");
  const [activeTab, setActiveTab] = useState(
    isTenable
      ? TENABLE_TABS[0].key
      : DEFAULT_TAB_DATA[0]?.key
  );

  if (isTenable) {
    const tabData = TENABLE_TABS.map((tab) => ({
      ...tab,
      function:
        tab.key === TAB_KEYS.VULNERABILITY_MANAGEMENT && activeTab === TAB_KEYS.VULNERABILITY_MANAGEMENT
          ? <VulnerabilityManagementTab />
          : tab.key === TAB_KEYS.CIS_BENCHMARK && activeTab === TAB_KEYS.CIS_BENCHMARK
          ? <CISBenchmarkTab />
          : <></>,
    }));

    return (
      <div className="config-tables-wrapper">
        <CustomTab
          data={tabData}
          activeKey={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
    );
  }

  return (
    <div className="config-tables-wrapper">
      {DEFAULT_TAB_DATA[0]?.function}
    </div>
  );
};

ConfigTables.propTypes = {
  toolName: PropTypes.string.isRequired,
};

export default ConfigTables;